import { useState } from "react";
import { useQuery } from "react-query";
import { taskService, isTaskClosed } from "api/ai/ai.service";
import { VStack, Progress } from "@chakra-ui/react";
import { SmallText } from "components/text/TextTypes";
import { truncate } from "lodash";
import { space } from "utils/text-utils";
import { colors } from "theme/foundations/colors";
/**
 * Show the progress of an AI task -- because it can take a while to run, and the user needs to know it's running.
 */
export default function AIProgressWidget({ task, taskId, error, refetchInterval = 5000 }) {
  const [freshTask, setFreshTask] = useState(task);
  if (!taskId) {
    taskId = task?.id;
  }
  useQuery({
    queryKey: ["ai-task", taskId],
    queryFn: () => taskService.get(taskId),
    onSuccess: (data) => {
      setFreshTask(data);
    },
    refetchInterval,
    // If task provided and no refetch -- then no query wanted. If the task is done, failed or cancelled, then no point querying for updates.
    enabled: taskId && (!freshTask || (refetchInterval > 0 && !isTaskClosed(freshTask))),
  });
  if (!taskId && !error && !task) {
    return null;
  }
  const color = colors.aiTaskStatus[freshTask?.status];
  // how much progress to show?
  let value = freshTask?.progress ? 100 * freshTask.progress : 0;
  if (freshTask?.status === "done") value = 100;
  value = Math.max(value, 10); // always show something so we can see the colour

  return (
    <VStack gap={0}>
      {error && (
        <SmallText color="red" title={error.message || "" + error}>
          {truncate(error.message || "" + error, 100)}
        </SmallText>
      )}
      <Progress
        size="sm"
        width="50px"
        isIndeterminate={!freshTask?.status || !freshTask?.status === "draft"}
        colorScheme={color}
        value={value}
        title={space(freshTask?.status, freshTask?.outputs?.length && "done: " + freshTask.outputs.length)}
      />
      {freshTask?.progress && <SmallText>{Math.round(100 * freshTask?.progress)}%</SmallText>}
    </VStack>
  );
}
